import Vue from 'vue'
import Vuex from 'vuex'
import VuexORM from '@vuex-orm/core'
import database from '@/store/database'
import * as api from '@/api'
import { stateGetters, stateSetters } from '@/store/store-utils'

// global state
import actions from '@/store/actions'
import socketActions from '@/store/socket_actions'

import modules from '@/store/modules'

Vue.use(Vuex)

const initialState = {
  loaded: false,
  localeLoaded: false,
  shuttingDown: false,
  online: 0,
  socket: {
    connected: false,
    reconnectionAttempts: 0,
  },
  ui: {
    sidebar: {
      open: true,
    },
    chat: {
      open: true,
    },
  },
  namespaces: [],
  gamesSummaries: null,
  windowVisible: true,
  userActive: true,
}

const store = new Vuex.Store({
  state: () => initialState,
  getters: {
    ...stateGetters(initialState),
    connected: s => s.socket.connected,
  },
  mutations: {
    ...stateSetters(initialState),
    setConnected: (state, v) => { state.socket.connected = v },
    setReconnectAttempt: (state, v) => {
      state.socket.reconnectionAttempts = v
    },
    incReconnectAttempt: state => {
      state.socket.reconnectionAttempts += 1
    },
    setSidebarOpen: (state, val) => {
      state.ui.sidebar.open = val
    },
    setChatOpen: (state, val) => {
      state.ui.chat.open = val
    },
    addNamespace: (state, val) => {
      if (state.namespaces.includes(val)) return
      state.namespaces.push(val)
    },
    removeNamespace: (state, val) => {
      state.namespaces = state.namespaces.filter(ns => ns !== val)
    },
  },
  actions: {
    ...socketActions,
    ...actions,
  },
  modules,
  plugins: [VuexORM.install(database)],
  strict: process.env.NODE_ENV !== 'production',
})

store.$api = api

export default store
